import React from 'react'
import FacebookIcon from './FacebookIcon'
import TwitterIcon from './TwitterIcon'
import InstagramIcon from './InstagramIcon'

const SocialLinks = ({ twitter, facebook, instagram }) => {
  if (!twitter && !facebook && !instagram) {
    return <p>Aún no tenemos links para este candidato.</p>
  }
  return (
    <div>
      {twitter && twitter !== 'No' && (
        <h4 className="py-4 leading-none truncate truncate-content sm:py-0 sm:my-2">
          <a
            className="flex align-baseline hover:text-azul hover:underline"
            href={twitter}
            target="_blank"
            rel="noopener noreferrer">
            <TwitterIcon className="inline-block w-4 h-4 mr-1 text-gray-500" />{' '}
            <strong className="inline-block font-normal leading-none ">
              {twitter
                .split('?')[0]
                .replace('https://twitter.com/', '')
                .replace('https://www.twitter.com/', '')
                .replace('/', '')}
            </strong>
          </a>
        </h4>
      )}
      {facebook && facebook !== 'No' && (
        <h4 className="py-4 leading-none truncate truncate-content sm:py-0 sm:my-2">
          <a
            className="flex align-baseline hover:text-azul hover:underline"
            href={facebook}
            target="_blank"
            rel="noopener noreferrer">
            <FacebookIcon className="inline-block w-4 h-4 mr-1 text-gray-500" />{' '}
            <strong className="inline-block font-normal leading-none ">
              {decodeURI(
                facebook
                  .split('?')[0]
                  .replace('https://www.facebook.com/', '')
                  .replace('https://web.facebook.com/', '')
                  .replace('/', ''),
              )}
            </strong>
          </a>
        </h4>
      )}
      {instagram && instagram !== 'No' && (
        <h4 className="py-4 leading-none truncate sm:py-0 sm:my-2">
          <a
            className="flex align-baseline hover:text-azul hover:underline"
            href={instagram}
            target="_blank"
            rel="noopener noreferrer">
            <InstagramIcon className="inline-block w-4 h-4 mr-1 text-gray-500" />{' '}
            <strong className="inline-block font-normal leading-none ">
              {instagram
                .split('?')[0]
                .replace('https://www.instagram.com/', '')
                .replace('https://instagram.com/', '')
                .replace('/', '')}
            </strong>
          </a>
        </h4>
      )}
    </div>
  )
}

export default SocialLinks
